import { useState, Fragment } from "react";
import "./ParentHeader.scss";
import ParentHeaderLeft from "./parentHeaderLeft/ParentHeaderLeft";
import ParentHeaderRight from "./parentHeaderRight/ParentHeaderRight";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ParentHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <Fragment>
      <div className="parent-header_component_wrapper">
        <div className="parent-header_inner_container">
          <div className="header_inner_wrapper">
            <div className="hamburger_icon" onClick={toggleMenu}>
              <GiHamburgerMenu />
            </div>
            <div className="header_left_wrapper">
              <ParentHeaderLeft />
            </div>
            <div className="header_right_wrapper">
              <ParentHeaderRight />
            </div>
          </div>
        </div>
        <div className={`mobile_menu_container ${isMenuOpen ? "open" : ""}`}>
          <div className="mobile_menu_header">
            <button className="close_button" onClick={toggleMenu}>
              <IoClose />
            </button>
          </div>
          <ParentHeaderLeft />
        </div>
        {isMenuOpen && <div className="mobile_menu_overlay" onClick={toggleMenu}></div>}
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default ParentHeader;